import { Helmet } from "react-helmet-async";

// Vuokrattavat-sivun SEO + OG + Twitter
function RentalHelmetComponent() {
  const title =
    "Tapahtumatekniikan vuokraus | Äänentoisto ja valot – Spiderlegs Productions";

  const description =
    "Vuokraa äänentoistopaketit, valot ja muu tapahtumatekniikka äänen, valon ja esitystekniikan tarpeisiin. Varaa vuokrakalusto suoraan kalenterista.";

  const url = "https://spiderlegsproductions.com/vuokrattavat/";

  const image = "https://spiderlegsproductions.com/assets/new_logo.webp";

  return (
    <Helmet>
      {/* Title */}
      <title>{title}</title>

      {/* Meta description */}
      <meta name="description" content={description} />

      {/* Keywords: ei kriittinen Googlelle, mutta pidetään siistinä ja sivun aiheeseen liittyvänä */}
      <meta
        name="keywords"
        content="tapahtumatekniikan vuokraus, äänentoiston vuokraus, valotekniikan vuokraus, PA-laitteet, kaiuttimet, mikrofonit, valot, savukone, laitevuokraus"
      />

      {/* Author */}
      <meta name="author" content="Spiderlegs Productions" />

      {/* Canonical */}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Spiderlegs Productions" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default RentalHelmetComponent;